import { render, staticRenderFns } from "./commodityInfo.vue?vue&type=template&id=0261a6d8&scoped=true&"
import script from "./commodityInfo.vue?vue&type=script&lang=js&"
export * from "./commodityInfo.vue?vue&type=script&lang=js&"
import style0 from "./commodityInfo.vue?vue&type=style&index=0&id=0261a6d8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0261a6d8",
  null
  
)

export default component.exports